export const entities = [
  { name: "Individual" },
  { name: "Partnership" },
  { name: "Limited Liability Company" },
  { name: "Corporation" },
];


export const llc = [
  { name: "Limited Company (Ltd)" },
  { name: "Public Limited Company (PLC)" },
  { name: "Limited Liability Partnership (LLP)" },
  { name: "Corporation" },
];

